import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Fix for "process is not defined" error
if (typeof window !== 'undefined' && !window.process) {
    window.process = { env: { NODE_ENV: 'production' } };
}

import './WebPPlayer.css';

class WebPPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null,
            isLoaded: false
        };
        this.imageRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.animatedUrl) {
            this.loadWebP(this.props.animatedUrl);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.animatedUrl !== this.props.animatedUrl && this.props.animatedUrl) {
            this.loadWebP(this.props.animatedUrl);
        }
    }

    loadWebP = (url) => {
        if (!url) return;

        this.setState({ isLoading: true, error: null, isLoaded: false });
        
        const img = new Image();
        
        img.onload = () => {
            this.setState({ 
                isLoading: false, 
                error: null,
                isLoaded: true 
            });
        };
        
        img.onerror = (error) => {
            console.error('WebP loading error:', error);
            console.error('URL that failed:', url);
            
            let errorMessage = 'Không thể load WebP image.';
            
            // Check for CORS error
            if (error && error.message && error.message.includes('CORS')) {
                errorMessage = 'Lỗi CORS: Không thể truy cập file từ domain này.';
            } else if (error && error.type === 'error') {
                errorMessage = 'Lỗi network: Không thể tải file.';
            }
            
            this.setState({ 
                isLoading: false, 
                error: errorMessage,
                isLoaded: false
            });
        };
        
        img.src = url;
    }

    handleImageClick = () => {
        if (this.props.onClick) {
            this.props.onClick({
                animatedUrl: this.props.animatedUrl,
                giftName: this.props.giftName,
                fileType: 'webp',
                isLoaded: this.state.isLoaded
            });
        }
    }

    render() {
        const { 
            animatedUrl, 
            giftName = 'WebP Image',
            width = '100%', 
            height = '100%', 
            className = '',
            showButton = false,
            size = 'medium'
        } = this.props;

        const { isLoading, error, isLoaded } = this.state;

        if (!animatedUrl) {
            return (
                <div className={`webp-player-container ${className} ${size}`}>
                    <div className="webp-placeholder">
                        <span>Không có ảnh</span>
                    </div>
                </div>
            );
        }

        return (
            <div className={`webp-player-container ${className} ${size}`}>
                <div 
                    className="webp-content"
                    style={{
                        width: width,
                        height: height,
                        cursor: this.props.onClick ? 'pointer' : 'default'
                    }}
                    onClick={this.handleImageClick}
                    title={giftName}
                >
                    {isLoading && (
                        <div className="webp-loading">
                            <div className="loading-spinner"></div>
                            <span>Đang tải...</span>
                        </div>
                    )}

                    {error && (
                        <div className="webp-error">
                            <span>⚠️ {error}</span>
                            <div style={{ marginTop: '8px', fontSize: '10px', textAlign: 'center' }}>
                                <a href={animatedUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#fff', textDecoration: 'underline' }}>
                                    🔗 Mở trong tab mới
                                </a>
                            </div>
                        </div>
                    )}

                    {isLoaded && !error && (
                        <img 
                            src={animatedUrl} 
                            alt={giftName}
                            className="webp-image"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    )}

                    {showButton && isLoaded && !error && (
                        <div className="webp-button-overlay">
                            <button 
                                className="webp-view-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleImageClick();
                                }}
                            >
                                🖼️ Xem
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

WebPPlayer.propTypes = {
    animatedUrl: PropTypes.string,
    giftName: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    showButton: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    onClick: PropTypes.func
};

WebPPlayer.defaultProps = {
    showButton: false,
    size: 'medium'
};

export default WebPPlayer; 